<template>
  <div class="contentRight2">
    <div class="rightHead">
      <div style="padding: 20px 0px 10px 25px;font-size:15px;padding-top:16px;color:#707070;">充值送</div>
    </div>
    <div class="contentTabs">
      <div class="from">
        <el-form
          hide-required-asterisk
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="活动名称：" prop="activityName">
            <el-input size="small" v-model="ruleForm.activityName"></el-input>
          </el-form-item>
          <el-form-item label="充值金额：">
            <div class="activityList" v-for="(item,index) in activityList" :key="index">
              <span style="margin-left:0">充</span>
              <el-input size="small" class="input1" type="text" placeholder="请输入数字" v-model="item.rechargeMoney" onchange = "this.value=this.value.replace(/[^\d]/g,'')"></el-input>
              <span>送</span>
              <el-input class="input1" size="small" v-model="item.handselMoney" placeholder="请输入数字" onchange = "this.value=this.value.replace(/[^\d]/g,'')"></el-input>
              <span class="text1" @click="add" v-if="item.type">添加</span>
              <span class="text2" @click="del(index)" v-else>删除</span>
            </div>
          </el-form-item>
          <el-form-item label="活动时间：" prop>
            <el-radio-group v-model="ruleForm.expireType">
              <el-radio label="永久"></el-radio>
              <el-radio label="设置时间"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="ruleForm.expireType == '设置时间'" label prop="date">
            <el-date-picker
              v-model="ruleForm.date"
              size="small"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="会员卡：" prop="shopMemberCardIds">
            <el-select size="small" v-model="ruleForm.shopMemberCardIds" multiple placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.shopMemberCardId"
                :label="item.cardName"
                :value="item.shopMemberCardId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label prop>
            <el-button type="primary" @click="submitForm('ruleForm')">发布活动</el-button>
            <el-button @click="resetForm('ruleForm')">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import { shopMemberActivityList } from "../api";
export default {
  name: "charge",
  data() {
    // var rechargeMoneyRule = (rule, value, callback) => {
    //   if (!value) {
    //     return callback(new Error("充值不能为空"));
    //   } else if (!this.ruleForm.handselMoney) {
    //     return callback(new Error("赠送金额不能为空"));
    //   } else {
    //   }
    // };
    return {
      options: [
        {
          value: "选项1",
          label: "黄金糕"
        },
        {
          value: "选项2",
          label: "双皮奶"
        },
        {
          value: "选项3",
          label: "蚵仔煎"
        },
        {
          value: "选项4",
          label: "龙须面"
        },
        {
          value: "选项5",
          label: "北京烤鸭"
        }
      ],
      value1: "",
      value2: "",
      ruleForm: {
        activityName: "",
        rechargeMoney: "",
        handselMoney: "",
        expireType: "永久",
        date: [],
        shopMemberCardIds: ""
      },
      rules: {
        activityName: [
          { required: true, message: "请输入活动名称", trigger: "blur" }
        ],
        shopMemberCardIds: [
          { required: true, message: "请选择会员卡", trigger: "blur" }
        ],
        date: [{ required: true, message: "请选择时间", trigger: "blur" }],
        // rechargeMoney: [{ validator: rechargeMoneyRule, trigger: "blur" }]
      },
      userList: "",
      shopInformation: "",
      activityList: [
        {
          rechargeMoney: "",
          handselMoney: "",
          type: true
        }
      ]
    };
  },
  created() {
    let userList = JSON.parse(this.getCookie("userList"));
    let shopInformation = JSON.parse(this.getCookie("shopInformation"));
    this.userList = userList;
    this.ShopMemberActivity_shopMemberActivityList();
    shopMemberActivityList({
      userId: this.userList.id, //用户Id
      sessionId: this.userList.sessionId
    }).then(res => {
      var arr = [];
      for (let i in res.data) {
        if (res.data[i].isEnable == 1) {
          arr.push(res.data[i]);
        }
      }
      this.options = arr;
    });
  },
  methods: {
    //查询活动列表
    ShopMemberActivity_shopMemberActivityList() {
      this.request
        .post("qrcapi/ShopMemberActivity_shopMemberActivityList", {
          userId: this.userList.id, //用户Id
          sessionId: this.userList.sessionId
          // isEnable:1,
        })
        .then(res => {
          console.log(res, "huodong");
          if (res.code == 1) {
            var shopMemberCardIds = res.data[0].shopMemberCardIds.split(",");
            this.ruleForm.activityName = res.data[0].activityName;
            if (res.data[0].expireType == 1) {
              this.ruleForm.expireType = "设置时间";
              this.ruleForm.date[0] = res.data[0].startTime;
              this.ruleForm.date[1] = res.data[0].endTime;
            } else {
              this.ruleForm.expireType = "永久";
            }
            var list = JSON.parse(res.data[0].itemContent);
            list[0].type = true;
            this.activityList = list;
            console.log(list, "list");
            console.log(shopMemberCardIds, "1");
            for (let i in shopMemberCardIds) {
              shopMemberCardIds[i] = Number(shopMemberCardIds[i]);
            }
            this.ruleForm.shopMemberCardIds = shopMemberCardIds;
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            // this.$message.error(res.msg);
          }
        });
    },
    //添加活动
    ShopMemberActivity_pubActivity() {
      var arr = this.activityList;
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].handselMoney == "" || arr[i].rechargeMoney == "") {
          this.$message.error("充值金额或赠送金额不能为空")
          return
        } else if (arr[i].handselMoney < arr[i].rechargeMoney) {
          // this.$message.error("充值金额不能小于赠送金额哦")说
        }
      }
      var ruleForm = this.ruleForm;
      arr = JSON.stringify(arr);
      var expireType = ruleForm.expireType;
      if (expireType == "永久") {
        expireType = 0;
      } else {
        expireType = 1;
      }
      this.request
        .post("qrcapi/ShopMemberActivity_pubActivity", {
          userId: this.userList.id, //用户Id
          sessionId: this.userList.sessionId,
          activityName: ruleForm.activityName,
          itemContent: arr,
          activityType: 1,
          expireType: expireType, //活动时间类型   0 永久 1 按日期
          startTime: ruleForm.date[0],
          endTime: ruleForm.date[1],
          shopMemberCardIds: String(ruleForm.shopMemberCardIds),
          isEnable: 1
        })
        .then(res => {
          if (res.code == 1) {
            this.$message({
              type: "success",
              message: "发布成功!"
            });
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    del(index) {
      this.activityList.splice(index, 1);
    },
    add() {
      var arr = this.activityList;
      if (arr.length < 3) {
        arr.push({
          rechargeMoney: "",
          handselMoney: "",
          type: false
        });
      } else {
        this.$message.error("最多添加3个活动");
      }
    },
    submitForm(formName) {
      console.log(this.ruleForm);
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.ShopMemberActivity_pubActivity();
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      // this.$refs[formName].resetFields();
      this.ruleForm = {
        activityName: "",
        rechargeMoney: "",
        handselMoney: "",
        expireType: "永久",
        date: [],
        shopMemberCardIds: ""
      };
      this.activityList = [
        {
          rechargeMoney: "",
          handselMoney: "",
          type: true
        }
      ];
    }
  }
};
</script>

<style scoped>
.from {
  margin-top: 70px;
  margin-left: 30px;
  width: 600px;
}
.input1 {
  width: 170px;
}
.activityList span {
  margin: 0 10px;
}
.text1 {
  color: #108ee9;
  cursor: pointer;
}
.text2 {
  color: #ff2d46;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/page/charge.vue